// extracted by mini-css-extract-plugin
module.exports = {"box":"AutoRankingCard_box__3CD4y","text":"AutoRankingCard_text__2qLm9","num":"AutoRankingCard_num__3W3qS"};